import { render } from "./NewDatasourceUpload.vue?vue&type=template&id=290a8ee9&ts=true"
import script from "./NewDatasourceUpload.vue?vue&type=script&lang=ts"
export * from "./NewDatasourceUpload.vue?vue&type=script&lang=ts"

import "./NewDatasourceUpload.vue?vue&type=style&index=0&id=290a8ee9&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__